module.exports = __webpack_public_path__ + "img/9788992263221.73c5d0b2.jpg";